
export const initGA = (trackingID) => {
	window.gtag('js', new Date());
	window.gtag('config', trackingID);
}

export const PageView = () => {  
	window.gtag('event', 'page_view', {
      page_title:  window.location.pathname, //window.document.title
      page_path: window.location.pathname,
      page_location: window.location.href
    })
}

export const Event = (eventType, evtOption) => {	
	window.gtag('event', eventType, evtOption)
};
